<template>
	<div class="signin-bg">
		<Header :show_language_items="false" :show_menu_items="false" :is_sticky="true" />
		<div class="inblock">
			<div class="step" v-show="step==1">
				<h4 class="inblock-title">
					{{ $t("message.ng_register.choose_your_function") }}
				</h4>
				<FormSeparator />
				<SimpleSelect v-model="role" :options="roles" :label="$t('message.ng_register.choose')" />
				<FormSeparator />
				<ButtonSuccess :disabled="role==''" :label="$t('message.ng_register.submit')" @click="nextStep"/>
			</div>
			<div class="step" v-show="step==2">
				<div class="signup-header">
					<ButtonLink size="sm" @click="step--" :label="$t('message.back')">
						<template v-slot:icon>
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentcolor">
								<path d="M6.86193 2.86193C7.12228 2.60158 7.54439 2.60158 7.80474 2.86193C8.06509 3.12228 8.06509 3.54439 7.80474 3.80474L4.276 7.33333H13.3333C13.6752 7.33333 13.957 7.5907 13.9955 7.92225L14 8C14 8.36819 13.7015 8.66667 13.3333 8.66667H4.276L7.80474 12.1953C8.04506 12.4356 8.06355 12.8137 7.8602 13.0753L7.80474 13.1381C7.54439 13.3984 7.12228 13.3984 6.86193 13.1381L2.19526 8.47141L2.14646 8.41697C2.14491 8.41504 2.14338 8.41311 2.14186 8.41117C2.13819 8.40656 2.1345 8.40174 2.13089 8.39687C2.11899 8.38075 2.10781 8.36418 2.09738 8.34711C2.0924 8.33908 2.08767 8.33093 2.08311 8.32271C2.07586 8.30953 2.06892 8.29593 2.06244 8.28207C2.05712 8.27073 2.05213 8.2592 2.04748 8.24756C2.04221 8.23439 2.03742 8.2212 2.03303 8.20783C2.02982 8.1979 2.02673 8.18764 2.0239 8.17733C2.01989 8.16296 2.01643 8.1485 2.01344 8.13386C2.01113 8.12225 2.00909 8.11063 2.00735 8.09898C2.00251 8.06691 2 8.03375 2 8L2.00264 8.0595C2.00126 8.044 2.00042 8.02846 2.00012 8.0129L2 8C2 7.99573 2.00004 7.99147 2.00012 7.98722C2.0004 7.97199 2.00124 7.95622 2.00264 7.9405C2.00384 7.92677 2.00541 7.91367 2.00735 7.90069C2.00909 7.88937 2.01113 7.87775 2.01349 7.86618C2.01643 7.8515 2.01989 7.83704 2.02381 7.82278C2.02673 7.81236 2.02982 7.8021 2.03316 7.79191C2.03741 7.7788 2.04221 7.76562 2.0474 7.75263C2.05213 7.7408 2.05712 7.72927 2.06245 7.71785C2.06892 7.70407 2.07586 7.69047 2.08325 7.67715C2.08767 7.66907 2.0924 7.66093 2.09733 7.65286C2.10781 7.63582 2.11899 7.61925 2.13088 7.60323C2.15021 7.57712 2.17167 7.55219 2.19526 7.5286L2.14186 7.58884C2.15845 7.56769 2.17628 7.54757 2.19526 7.5286L6.86193 2.86193Z" />
						</svg>
						</template>
					</ButtonLink>
					<FormSeparator h="55px"/>
				</div>
				<h4 class="inblock-title">
					{{ $t("message.ng_register.please_enter_data_below") }}
				</h4>
				<FormSeparator />
				<FormLabel :label="$t('message.ng_register.representative')" />
				<TextInput v-model="pull.customer_first_name" :placeholder="$t('message.ng_register.given_name')" :has_error="tried_validation && $v.pull.customer_first_name.$invalid" />
				<FormSeparator h="16px"/>
				<TextInput v-model="pull.customer_last_name" :placeholder="$t('message.ng_register.family_name')" :has_error="tried_validation && $v.pull.customer_last_name.$invalid" />
				<FormSeparator h="16px"/>
				<TextInput v-model="pull.customer_middlename" :placeholder="$t('message.ng_register.middle_name')" :has_error="tried_validation && $v.pull.customer_middlename.$invalid" />
				<FormSeparator h="16px"/>
				<TextInput v-model="pull.position" :placeholder="$t('message.ng_register.designation')" :has_error="tried_validation && $v.pull.position.$invalid" />
				<FormSeparator />
				<FormLabel :label="$t('message.ng_register.company')" />
				<div class="relative">
					<TextInput v-model="pull.company_id" :placeholder="$t('message.ng_register.tin')" :has_error="tried_validation && $v.pull.company_id.$invalid" />
					<div class="absolute float-button">
						<ButtonSecondary :label="$t('message.ng_register.get_tin')" @click="getTin()" />
					</div>
				</div>
				<FormSeparator h="16px"/>
				<TextInput v-model="pull.rc_number" :placeholder="$t('message.ng_register.rc_number')" :has_error="tried_validation && $v.pull.rc_number.$invalid" />
				<FormSeparator h="16px"/>
				<TextInput v-model="pull.company_title" :placeholder="$t('message.ng_register.company_name')" :has_error="tried_validation && $v.pull.company_title.$invalid" />
				<FormSeparator h="16px"/>
				<div class="grid-2-cols gap-md">
						<TextInput v-model="pull.state_code" :placeholder="$t('message.ng_register.state_code')" :has_error="tried_validation && $v.pull.state_code.$invalid" />
						<TextInput v-model="pull.city" :placeholder="$t('message.ng_register.city')" :has_error="tried_validation && $v.pull.city.$invalid" />
				</div>
				<FormSeparator h="16px"/>
				<TextInput v-model="pull.company_address" :placeholder="$t('message.ng_register.address')" :has_error="tried_validation && $v.pull.company_address.$invalid" />
				<FormSeparator h="16px"/>
				<div class="grid-2-cols gap-md">
						<TextInput v-model="pull.customer_phone" :placeholder="$t('message.ng_register.phone')" :has_error="tried_validation && $v.pull.customer_phone.$invalid" /><!--FIXME: we have customer_phone but not company phone-->
						<TextInput v-model="pull.fax" :placeholder="$t('message.ng_register.fax')" :has_error="tried_validation && $v.pull.fax.$invalid" /><!--FIXME: we don't havesuch field-->
				</div>
				<FormSeparator h="16px"/>
				<TextInput v-model="pull.customer_email" :placeholder="$t('message.ng_register.email')" :has_error="tried_validation && $v.pull.customer_email.$invalid" /> <!--FIXME: we have customer_email but not company email-->
				<FormSeparator h="16px"/>
				<div class="grid-2-cols gap-md">
						<PasswordInput v-model="pull.customer_password" :placeholder="$t('message.ng_register.password')" :has_error="tried_validation && $v.pull.customer_password.$invalid" />
						<PasswordInput v-model="pull.confirm_password" :placeholder="$t('message.ng_register.confirm_password')"  :has_error="tried_validation && $v.pull.confirm_password.$invalid" />
				</div>
				<FormSeparator />
				<div class="buttons-section flex gap-md">
					<ButtonSecondary :label="$t('message.ng_register.clear')" @click="clearPull" size="md" width="auto" />
					<ButtonSuccess :label="$t('message.ng_register.continue')" @click="nextStep" size="md" width="auto" />
				</div>
				
			</div>
			<div class="step" v-show="step==3">
				<div class="signup-header">
					<ButtonLink size="sm" @click="step--" :label="$t('message.back')">
						<template v-slot:icon>
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentcolor">
								<path d="M6.86193 2.86193C7.12228 2.60158 7.54439 2.60158 7.80474 2.86193C8.06509 3.12228 8.06509 3.54439 7.80474 3.80474L4.276 7.33333H13.3333C13.6752 7.33333 13.957 7.5907 13.9955 7.92225L14 8C14 8.36819 13.7015 8.66667 13.3333 8.66667H4.276L7.80474 12.1953C8.04506 12.4356 8.06355 12.8137 7.8602 13.0753L7.80474 13.1381C7.54439 13.3984 7.12228 13.3984 6.86193 13.1381L2.19526 8.47141L2.14646 8.41697C2.14491 8.41504 2.14338 8.41311 2.14186 8.41117C2.13819 8.40656 2.1345 8.40174 2.13089 8.39687C2.11899 8.38075 2.10781 8.36418 2.09738 8.34711C2.0924 8.33908 2.08767 8.33093 2.08311 8.32271C2.07586 8.30953 2.06892 8.29593 2.06244 8.28207C2.05712 8.27073 2.05213 8.2592 2.04748 8.24756C2.04221 8.23439 2.03742 8.2212 2.03303 8.20783C2.02982 8.1979 2.02673 8.18764 2.0239 8.17733C2.01989 8.16296 2.01643 8.1485 2.01344 8.13386C2.01113 8.12225 2.00909 8.11063 2.00735 8.09898C2.00251 8.06691 2 8.03375 2 8L2.00264 8.0595C2.00126 8.044 2.00042 8.02846 2.00012 8.0129L2 8C2 7.99573 2.00004 7.99147 2.00012 7.98722C2.0004 7.97199 2.00124 7.95622 2.00264 7.9405C2.00384 7.92677 2.00541 7.91367 2.00735 7.90069C2.00909 7.88937 2.01113 7.87775 2.01349 7.86618C2.01643 7.8515 2.01989 7.83704 2.02381 7.82278C2.02673 7.81236 2.02982 7.8021 2.03316 7.79191C2.03741 7.7788 2.04221 7.76562 2.0474 7.75263C2.05213 7.7408 2.05712 7.72927 2.06245 7.71785C2.06892 7.70407 2.07586 7.69047 2.08325 7.67715C2.08767 7.66907 2.0924 7.66093 2.09733 7.65286C2.10781 7.63582 2.11899 7.61925 2.13088 7.60323C2.15021 7.57712 2.17167 7.55219 2.19526 7.5286L2.14186 7.58884C2.15845 7.56769 2.17628 7.54757 2.19526 7.5286L6.86193 2.86193Z" />
						</svg>
						</template>
					</ButtonLink>
					<FormSeparator h="55px"/>
				</div>
				<h4 class="inblock-title">
					{{ $t("message.ng_register.add_document") }}
				</h4>
				<FormSeparator />
				<FileUploader v-for="(file, index) in role_files" :ref="'file'+index" :index="index+1" :key="index" :loaded_error="role_files_errors[index]" :label="file.label" :type="file.type" :multiple="file.multiple" @update="$event => updateFile(index, $event)"/>
				<FormSeparator />
				<div class="buttons-section flex gap-md">
					<ButtonSecondary :label="$t('message.ng_register.submit')" @click="submitDocument" size="md" width="auto" />
				</div>
			</div>
			<div class="step" v-show="step==4">
				<h4 class="inblock-title text-primary">
					{{ $t("message.ng_register.registration_successful") }}
				</h4>
				<FormSeparator />
				<p>
					The message with activation link has been sent to your email.
				</p>
				<FormSeparator />
				<ButtonSuccess :label="$t('message.ng_login.login')" @click="gotoLogin" size="lg" width="full" />
			</div>
			</div>								
		</div>
</template>
<script>
import Header from '../newhomepage/header.vue';
import FileUploader from './FileUploader.vue';
// import { required, alpha, sameAs, sameAsPassword } from '@vuelidate/validators'
import { required, alpha, sameAs, sameAsPassword, email  } from 'vuelidate/lib/validators'
import { 
	TextInput, 
	PasswordInput, 
	FormSeparator, 
	ButtonLink, 
	ButtonSuccess, 
	ButtonWhite, 
	SimpleSelect, 
	FormLabel, 
	ButtonSecondary
} from "../simplements";
	export default {
		name: "NCSSignup",
		components: { 
			Header, 
			TextInput, 
			PasswordInput, 
			FormSeparator, 
			ButtonLink, 
			ButtonSuccess, 
			ButtonWhite, 
			SimpleSelect, 
			FormLabel, 
			FormSeparator, 
			ButtonSecondary, 
			FileUploader
		},
		data(){
			return {
				pull: {
					customer_last_name: '',
					customer_first_name: '',
					customer_middlename: '',

					customer_email: '',
					customer_password: '',
					customer_phone: '',

					position: '',
					company_id: '',
					rc_number: '', //new
					company_title: '',
					state_code: '', //new
					city: '', //new 
					company_address: '',
					fax: '', //new
					confirm_password: '',
				},
				role_files: [],
				role_files_errors: [],
				role_files_documents_errors: [],
				files: {
					adb: [
						{
							type: 'statute-of-bank',
							label: 'Statute of the Bank',
							multiple: false
						},
						{
							type: 'ncs-approval',
							label: 'NCS Approval',
							multiple: false
						},
						{
							type: 'cbn-license',
							label: 'CBN License',
							multiple: false
						},
					],
					importer: [
						{
							type: 'statute',
							label: 'Statutes',
							multiple: true
						},
						{
							type: 'license',
							label: 'Licenses',
							multiple: true
						},
						{
							type: 'certificate',
							label: 'Certificates',
							multiple: true
						},
					],
					licensedagent: [
						{
							type: 'authoritycard',
							label: 'Authority card',
							multiple: false
						},
						{
							type: 'certificate',
							label: 'Certificate',
							multiple: false
						},
						{
							type: 'currentlicense',
							label: 'Current license',
							multiple: false
						},
					],
					shippinglines: [
						{
							type: 'statute',
							label: 'Statute',
							multiple: false
						},
						{
							type: 'license',
							label: 'Licenses',
							multiple: true
						},
						{
							type: 'certificate',
							label: 'Certificates',
							multiple: true
						}
					],
					exporter: [
						{
							type: 'statute',
							label: 'Statutes',
							multiple: true
						},
						{
							type: 'license',
							label: 'Licenses',
							multiple: true
						},
						{
							type: 'certificate',
							label: 'Certificates',
							multiple: true
						},
					],
					manufacture: [
					{
							type: 'license',
							label: 'License',
							multiple: false
						},
					],
				},
				roles: [
					{
						value: 'adb',
						display_text: 'Authorised Dealer Bank'
					},
					{
						value: 'importer',
						display_text: 'Importer'
					},
					{
						value: 'licensedagent',
						display_text: 'Licensed Agent'
					},
					{
						value: 'shippinglines',
						display_text: 'Shipping lines'
					},
					{
						value: 'exporter',
						display_text: 'Exporter'
					},
					{
						value: 'manufacture',
						display_text: 'Manufacture'
					},
				],
				role: '',
				step: 1,

				tried_validation: false
			}
		},
		watch: {
			role(){
				this.role_files_documents_errors = []
				this.role_files = [...this.files[this.role]].map(item=>{
					item.loaded_error = false
					item.documents = []
					return item
				})
			}
		},
		methods: {
			gotoLogin(){
				this.$router.push({name: 'sign-in'})
			},
			validateDocuments(){
				let result = true
				this.role_files.forEach((file, fileindex)=>{
					if(!file.loaded){
						result = false
						this.$set(this.role_files_errors, fileindex, true)
					}else{
						console.log(this.$refs['file'+fileindex], this.$refs['file'+fileindex][0].validate)
						this.$set(this.role_files_errors, fileindex, false)
						file.documents.forEach((document, docindex)=>{
							if(document.date==''){
								this.$refs['file'+fileindex][0].validate()
								result = false
							}else{
								this.$refs['file'+fileindex][0].validate()
							}
							if(document.reference_number==''){
								this.$refs['file'+fileindex][0].validate()
								result = false
							}else{
								this.$refs['file'+fileindex][0].validate()
							}
						})
					}
				})
				return result
			},
			submitDocument(){
				if(this.validateDocuments()){
					var fd = new FormData();
					for (var i in this.pull) {
						fd.append(i, this.pull[i]);
					}
					fd.append('role', this.role)
					for(var i in this.role_files){
						for(var j in this.role_files[i].documents){
							fd.append(`file_id[${i}]`, this.role_files[i].documents[j].file_id)
							fd.append(`file_date[${i}]`, this.role_files[i].documents[j].date)
							fd.append(`file_reference_number[${i}]`, this.role_files[i].documents[j].reference_number)
							fd.append(`file_type[${i}]`, this.role_files[i].type)
						}
					}
					axios
							.post(window.base + "/account/register", fd)
							.then((response) => {
									if (response.data.statusCode == 200) {
										this.step++
									} else {
											new Noty({
													theme: "light",
													type: "error",
													text: response.data.statusMessage
															? response.data.statusMessage
															: response.data,
													timeout: 5000,
											}).show();
									}
							})
							.catch((error) => {
									new Noty({
											theme: "light",
											type: "error",
											text: error.response.data,
											timeout: 5000,
									}).show();
									this.loading = false;
							});
				}
			},
			updateFile(fileindex, {loaded, documents}){
				this.$set(this.role_files[fileindex], 'loaded', loaded)
				this.$set(this.role_files[fileindex], 'documents', documents)
				this.validateDocuments()
			},
			getTin(){
				axios.get(`https://apps.firs.gov.ng/apis/tinvalidation/${this.pull.company_id}`).then(response=>{
					console.log(response.data)
				})
			},
			clearPull(){
				this.$set(this, 'pull', {
					customer_last_name: '',
					customer_first_name: '',
					customer_middlename: '',
					position: '',
					company_id: '',
					rc_number: '',
					company_title: '',
					state_code: '',
					city: '',
					company_address: '',
					phone: '',
					fax: '',
					email: '',
					password: '',
					confirm_password: '',
				})
			},
			nextStep(){
				if(this.step==1){
					if(this.role!=='')
						this.step++

					return;
				}
				if(this.step==2){
					this.$v.$touch('pull')
					this.tried_validation = true
					if(!this.$v.pull.$invalid)
						this.step++ //TODO: make validation before moving to next step
					return;
				}
			}
		},
		validations() {
      return {
        pull: {
										customer_last_name: {
            required,
            // alpha: (val) => /^[а-яёa-zәғқңөұүh]*$/i.test(val),
          },
          customer_first_name: {
            required,
            // alpha: (val) => /^[а-яёa-zәғқңөұүh]*$/i.test(val),
          },
          customer_middlename: {
            // alpha: (val) => /^[а-яёa-zәғқңөұүhі]*$/i.test(val),
          },
          customer_email: {
            required,
            email,
          },
          customer_password: {
            required,
            // password: (val) =>
            //   /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&,\.])[A-Za-z\d@$!%*#?&,\.]+$/.test(
            //     val,
            //   ),
          },
										confirm_password: {
											required,
											// sameAs: sameAs(this.pull.password)
										},
          position: {
            required,
          },
          company_address: {
            required,
          },
          company_id: {
            required,
          },
          rc_number: {
            required,
          },

          company_title: {
            required,
          },
          state_code: {
											required
										},
          city: {
            required,
          },
          customer_phone: {
											required
										},
          fax: {
            required,
          },
        },
      };
  },
	}
</script>
<style scoped>
	@import url('./../simplements/assets/basic.css');
	.signin-bg {
		background-color: #fff !important;
		/* background-image: url('./../newhomepage/img_bridge_2.png'); */
		min-height: 100vh !important;
		background-repeat: no-repeat;
		background-position: center right;
		overflow-y: auto;
	}
	.inblock{
		width: 28vw;
		margin: 181px auto;
	}

	.inblock-title{
		color: var(--neutral-10, rgba(51, 51, 51, 0.93));

		/* Display/Small */
		font-family: Roboto;
		font-size: 28px;
		font-style: normal;
		font-weight: 500;
		line-height: 32px; /* 114.286% */
		text-align: center;
	}
	.float-button{
		top: 0;
		right: 0;
		transform: translateX(calc(100% + var(--gap-md)));
	}
	.inblock-title.text-primary{
		color: var(--primary) !important;
	}
</style>